module.exports = __webpack_public_path__ + "img/empty.3e987443.png";